// Redesign 2026 – filtr projektů podle kategorie (Portfolio investic).
//
// Bez JS jsou vidět všechny projekty a tlačítka filtru se nevykreslí jako aktivní – stránka
// funguje dál, filtrování je jen zrychlení. Nefiltruje se serverem, projektů je řádově dvacet.
//
// Markup: [data-rd-project-filter] s tlačítky [data-rd-filter="<kategorie>"] (prázdná hodnota = vše),
// karty [data-rd-project-categories="A|B"] uvnitř [data-rd-project-grid], hláška [data-rd-project-empty].
// Projekt může patřit do víc kategorií, proto je na kartě seznam oddělený svislítkem.

const ACTIVE = 'is-active';

export default function initRedesignProjectFilter() {
  const group = document.querySelector('[data-rd-project-filter]');
  const grid = document.querySelector('[data-rd-project-grid]');
  if (!group || !grid) {
    return;
  }

  const buttons = [...group.querySelectorAll('[data-rd-filter]')];
  const empty = document.querySelector('[data-rd-project-empty]');
  const cards = [...grid.querySelectorAll('[data-rd-project-categories]')].map((el) => ({
    el,
    categories: el.dataset.rdProjectCategories.split('|').filter(Boolean),
  }));

  const apply = (category) => {
    let shown = 0;

    cards.forEach(({ el: card, categories }) => {
      const match = category === '' || categories.includes(category);
      card.hidden = !match;
      if (match) {
        shown += 1;
      }
    });

    buttons.forEach((button) => {
      const isActive = button.dataset.rdFilter === category;
      button.classList.toggle(ACTIVE, isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (empty) {
      empty.hidden = shown > 0;
    }
  };

  group.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rd-filter]');
    if (button) {
      apply(button.dataset.rdFilter);
    }
  });
}
